import React, { useState ,useEffect} from "react";
import { useLocation, useNavigate} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import Settings from "../Settings";
import {
    Menu,
    MenuItem,
    MenuSelectEvent,
    MenuItemLink,
} from "@progress/kendo-react-layout";
import * as svgIcons from "@progress/kendo-svg-icons";
import { SvgIcon } from "@progress/kendo-react-common";
import { useAppDispatch } from "./store.hooks";
import { toggleSidebar } from "../Common/Slices/SidebarSlice";
import { getDialogSelector, updateShareVisible } from "../Common/Slices/DialogSlice";
import { toggleMenu } from "../Common/Slices/MenuSlice";
import { useSelector } from "react-redux";
import { getParamsSelector } from "../Common/Slices/ParamSlice";
import Information from "../Information";
import ExternalNav from "./ExternalNav";
import FleetNav from "./FleetNav";

const ppLogoStyle = { width: "81px", height: "29px", }; //inline to override semantic list:img css
const backgroundMenu = {
    backgroundColor: "white",
    color: "#1a171b",
    fontSize: "1.2rem",
    padding: "8px",
};


const Navigation = (props: any) => {
    const params = useSelector(getParamsSelector)
    const navigate = useNavigate();

    const location = useLocation();

    const shareVisible = useSelector(getDialogSelector).shareVisible;

    const [settingsVisible, updateSettingsVisble] = useState(false);
    const [informationVisible, updateInformationVisible] = useState(false);
    const [sidebarOpen, updateSidebarOpen] = useState(true);
    const [menuOpen, updateMenuOpen] = useState(true);
    const [externalNavVisible, updateExternalNavVisible] = useState(false);
    const [selectedRoute, updateSelectedRoute] = useState("/machinetimes");
    const dispatch = useAppDispatch();
    const toggleSidebarOpen = () => {
        const toggle = !sidebarOpen;
        updateSidebarOpen(toggle);
        dispatch<any>(toggleSidebar({ isOpen: toggle }));
    }
 
    useEffect(() => {
        let newRoute = location.pathname;
        if (newRoute == "/" || newRoute == "/machinetimes/") newRoute = "/machinetimes";
        updateSelectedRoute(newRoute);
    }, [location]);
    const toggleInformation = () => {
        informationVisible ? updateInformationVisible(false) : updateInformationVisible(true);
    }
    const onSelect = (event: MenuSelectEvent) => {
        if(event.item.data && event.item.data.route){
            navigate(event.item.data.route,{state:params})
        }
    };
    const toggleSettings = () => {
        settingsVisible ? updateSettingsVisble(false) : updateSettingsVisble(true);
    };
    const toggleMenuOpen = () => {
        const toggle = !menuOpen
        updateMenuOpen(toggle)
        dispatch(toggleMenu({ isOpen: toggle }))
    }
    const toggleExternalNav = () => {
        externalNavVisible ? updateExternalNavVisible(false) : updateExternalNavVisible(true);
    }
    const shareHandler = () => {
        shareVisible ? dispatch(updateShareVisible(false)) : dispatch(updateShareVisible(true));
    };
  
    const logout = () => {
        props.logOut();
    };

    const sidebarIconColor = () => {
        
        if (sidebarOpen) {
            return "#fff"
        }
        else {
            return "#4fb9ff"
        }
    }
    const searchHandler = () => {
        window.open(
            "https://fleetmgmt.powerplatform.net/search",
            "_self"
        );
    }
    const menuIconColor = () => {
        if (menuOpen) {
            return "#fff"
        } else {
            return "#4fb9ff"
        }
    }
    const getMenuItemStyle = (text: string) => {
        if ("/" + text == selectedRoute) {
            return ({ color: "#4fb9ff ", backgroundColor: '#1a171b' })
        }
        else if (text == "mdc") {
            if (selectedRoute == "mdcScope" || selectedRoute == "mdcScopeRadar" || selectedRoute == "mdcTreeView") {
                return ({ color: "#4fb9ff ", backgroundColor: '#1a171b' })
            }
        }
        else {
            return ({ backgroundColor: "#1a171b", color: "#fff" });
        }
    }

    const renderMenu = () => {
        if (menuOpen) {
            return (<>

                <div className="navBar2" >
                    <FleetNav selectedRoute={selectedRoute}
                        params={params}
                    />
                </div>
                <div className="navBar3" >
                    <Menu
                        onSelect={onSelect}
                        vertical={false}
                    >
                            <MenuItem
                                text="Alarm Overview"
                                data={{ route: "/alarms" }}
                                cssStyle={getMenuItemStyle("alarms")}
                            />

                            <MenuItem
                                text="Machine Times"
                                data={{ route: "/machinetimes" }}
                                cssStyle={getMenuItemStyle("machinetimes")}
                            />
                            <MenuItem
                                text="Process Interrupts"
                                data={{ route: "/interrupt" }}
                                cssStyle={getMenuItemStyle("interrupt")}
                            />
                            {/*<MenuItem text="Running Periods" cssStyle={backgroundMenu}>*/}
                            {/*    <MenuItem*/}
                            {/*        text="Classification"*/}
                            {/*        data={{ route: "/runningperiodcategories" }}*/}
                            {/*        cssStyle={getMenuItemStyle("events")}*/}
                            {/*    />*/}

                            {/*    <MenuItem*/}
                            {/*        text="Very Short Periods Count"*/}
                            {/*        data={{ route: "/runningperiodcount" }}*/}
                            {/*        cssStyle={backgroundMenu}*/}
                            {/*    />*/}
                            {/*</MenuItem>*/}
                            <MenuItem
                                text="MDC Time Series"
                                data={{ route: "/mdc" }}
                                cssStyle={getMenuItemStyle("mdc")}
                            />
                            <MenuItem
                                text="MDC Totals"
                                data={{ route: "/mdcTotals" }}
                                cssStyle={getMenuItemStyle("mdcTotals")}
                            />
                            <MenuItem
                                text="Component Wear Out"
                                data={{ route: "/partwearout" }}
                                    cssStyle={getMenuItemStyle("partwearout")}
                            />
                    </Menu>
                </div>
            </>
            )
        }
    }
    return (
        <div>
            <div className="navBar">
                <div className="navigationMenu">
                    <img
                        src="../../assets/img/prima_logo_w.png"
                        style={ppLogoStyle}

                    />

                    <SvgIcon
                        style={{ color: menuIconColor(), cursor: "pointer" }}
                        icon={svgIcons.menuIcon}
                        size="medium"
                        onClick={() => toggleMenuOpen()}
                    />
                    <SvgIcon
                        style={{ color: sidebarIconColor(), cursor: "pointer" }}
                        icon={svgIcons.slidersIcon}
                        size="medium"
                        onClick={() => toggleSidebarOpen()}
                    />
                </div>
                <p
                    className="pp-header-text "
                    style={{
                        fontWeight: "bold",
                        fontSize: "17px",
                    }}
                >
                    <span style={{ cursor: "pointer" }} onClick={() => toggleExternalNav()}>
                        FLEET MANAGEMENT
                    </span>


                </p>
                <span className="right">     <SvgIcon
                    style={{
                        color: "#fff",
                        cursor: "pointer",
                        marginRight: "20px",
                        fontSize: "28px"
                    }}
                    icon={svgIcons.shareIcon}
                    size="medium"
                    onClick={() => shareHandler()}
                />
                    <SvgIcon
                        style={{
                            color: "#fff",
                            cursor: "pointer",
                            marginRight: "20px",
                            fontSize: "28px",
                        }}
                        icon={svgIcons.linkIcon}
                        size="medium"
                        onClick={() => toggleExternalNav()}
                    />


                    <SvgIcon
                        style={{
                            color: "#fff",
                            cursor: "pointer",
                            marginRight: "20px",
                            fontSize: "27px",
                        }}
                        icon={svgIcons.questionCircleIcon}
                        size="medium"
                        onClick={() => toggleInformation()}
                    />

                    <SvgIcon
                        style={{
                            color: "#fff",
                            cursor: "pointer",
                            marginRight: "30px",
                            fontSize: "28px",
                        }}
                        icon={svgIcons.gearsIcon}
                        size="medium"
                        onClick={() => toggleSettings()}
                    />

                    <span
                        className="menu ppLogOut pp-unselectable"
                        onClick={() => logout()}
                    >
                        <span className="ppLogOutIcon">
                            <FontAwesomeIcon icon={faSignOutAlt} />
                        </span>
                        Logout
                    </span>
                </span>
                <Settings visible={settingsVisible} toggleVisible={toggleSettings} />
                <Information
                    visible={informationVisible}
                    toggleVisible={toggleInformation}
                    id={null}
                />
                <ExternalNav
                    visible={externalNavVisible}
                    toggleVisible={toggleExternalNav}
                    selectedRoute={selectedRoute}
                    params={params}
                />
            </div>
            {renderMenu() }
        </div>
  )
}

export default Navigation
